// import { Grid } from "@mui/material";
// import classes from "./tableHeaders.module.css";

// const TableHeader = ({ pageHeader, headerIcon }) => {
//   return (
//     <Grid item xs={12} className={classes.container}>
//       <h2 className={classes.header}>
//         <span className={classes.headerIcon}> {headerIcon ? headerIcon : <Rectangle />}</span>
//         {pageHeader}
//       </h2>
//     </Grid>
//   );
// };

// export default TableHeader;

import classes from "./tableHeaders.module.css";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import TableRowsIcon from "@mui/icons-material/TableRows";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CompressIcon from "@mui/icons-material/Compress";
import ExpandIcon from "@mui/icons-material/Expand";
import { useState } from "react";
import { Grow } from "@mui/material";
import { toast } from "react-toastify";
import ColumnsPersonalizer from "../../NewTable/ColumnsPersonalizer/ColumnsPersonalizer";
import { ReactComponent as Rectangle } from "../../../images/icons/table/Rectangle.svg";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import MultiLanTxt from "../../UI/MultiLanTxt/MultiLanTxt";

const TableHeader = ({
  selectable,
  setFullScreen,
  density,
  fullScreen,
  selectAllRowsHandler,
  changeDensityHandler,
  setShowSearchRow,
  actionHandler,
  editablelity,
  canAdd,
  forceLtr,
  actionStatus,
  setActionStatus,
  tableInfos,
  setTableInfos,
  clonedTableInfos,
  headerIcon,
  pageHeader,
  additionalHeaderEndPartJsx,
  customAddTxt,
}) => {
  const [selectAll, setSelectAll] = useState(false);
  const [openShownColumnsEditor, setOpenShownColumnsEditor] = useState(false);

  const changeShownColumnHandler = (id, checekd) => {
    setTableInfos((ps) => {
      let newTableInfos = [...ps];
      let preferedIndex = newTableInfos.findIndex((inf) => inf.id === id);
      let newPreferedInf = { ...ps[preferedIndex] };
      newPreferedInf.show = checekd === undefined ? !newPreferedInf.show : checekd;
      newTableInfos[preferedIndex] = newPreferedInf;
      return newTableInfos;
    });
  };
  const showHideAllColumns = (e) => {
    setTableInfos((ps) => {
      let copiedTableInfos = [...ps];
      let newTableInfos = copiedTableInfos.map((each) => ({ ...each, show: true }));

      return newTableInfos;
    });
  };
  const pushToAddFormHandler = (e) => {
    if (editablelity) {
      if (actionStatus === "editing") {
        toast.warn("ابتدا فیلد تغییرات را ببندید");
      } else {
        setActionStatus("adding");
        setTableInfos(clonedTableInfos);
      }
    } else {
      actionHandler(null, "add");
    }
  };

  return (
    <div className={classes.container}>
      {openShownColumnsEditor ? (
        <div className={classes.columnEditBackDrop} onClick={() => setOpenShownColumnsEditor(false)} />
      ) : null}
      <div className={classes.startPart}>
        <h2 className={classes.header}>
          <span className={classes.headerIcon}> {headerIcon ? headerIcon : <Rectangle />}</span>
          {pageHeader}
        </h2>
      </div>
      <div className={classes.endPart}>
        {!canAdd || actionStatus === "adding" ? null : (
          <span className={classes.addTableFeatureContainer} onClick={pushToAddFormHandler}>
            <span className={classes.addTableFeatureIconContainer}>
              <AddBoxOutlinedIcon className={classes.addTableFeatureIcon} />
            </span>
            <span className={classes.addTableFeatureTxtContainer}>
              {forceLtr ? "Add" : customAddTxt ? customAddTxt : "اضافه کردن"}
            </span>
          </span>
        )}
        {additionalHeaderEndPartJsx ? additionalHeaderEndPartJsx : null}
        <span className={classes.searchIconContainer}>
          <span className={classes.tooltip}>{forceLtr ? "Search" : <MultiLanTxt tid="SEARCH" />}</span>
          <SearchIcon
            onClick={(e) => {
              e.preventDefault();
              setShowSearchRow((p) => !p);
            }}
            className={classes.tableFeatureIcon}
          />
        </span>
        <span className={classes.columnIconContainer}>
          <span className={classes.tooltip}>
            {forceLtr ? "Edit Columns" : <MultiLanTxt tid="EDIT_COLUMNS" />}
          </span>
          <ViewColumnIcon
            className={classes.tableFeatureIcon}
            onClick={(e) => {
              e.preventDefault();
              // if (actionStatus !== "editing" && actionStatus !== "adding") {
              setOpenShownColumnsEditor((p) => !p);
              // }
            }}
          />
        </span>
        <Grow in={openShownColumnsEditor} mountOnEnter unmountOnExit>
          <span className={classes.ColumnEditSpanContainer}>
            <div className={classes.scrollColumnEditSpanContainer}>
              <p className={classes.columnPersonlizer}>
                {forceLtr ? "Column personalizer" : "شخصی سازی ستون‌ها"}
              </p>
              <p className={classes.columns}>{forceLtr ? "Columns" : "ستون"}</p>
              <span className={classes.ColumnEditLine}>
                <input
                  className={classes.ColumnEditLineCheckBox}
                  type="checkbox"
                  id="allCols"
                  checked={!tableInfos.map((ea) => ea.show)?.includes(false)}
                  onChange={(e) => showHideAllColumns(e)}
                />
                <label className={classes.checkboxEditColumns} htmlFor="allCols">
                  {forceLtr ? "Show all columns" : "نمایش همه"}
                </label>
              </span>

              <ColumnsPersonalizer
                actionStatus={actionStatus}
                tableInfos={tableInfos}
                setTableInfos={setTableInfos}
                changeShownColumnHandler={changeShownColumnHandler}
              />
            </div>
          </span>
        </Grow>
        <span className={classes.rowIconContainer}>
          <span className={classes.tooltip}>
            {forceLtr ? "Row height" : <MultiLanTxt tid="ROW_HEIGHT" />}
          </span>
          {density === "normal" ? (
            <TableRowsIcon onClick={changeDensityHandler} className={classes.tableFeatureIcon} />
          ) : density === "compact" ? (
            <CompressIcon onClick={changeDensityHandler} className={classes.tableFeatureIcon} />
          ) : density === "large" ? (
            <ExpandIcon onClick={changeDensityHandler} className={classes.tableFeatureIcon} />
          ) : null}
        </span>
        <span className={classes.fullScreenIconContainer}>
          {fullScreen ? (
            <>
              <span className={classes.tooltip}>
                {forceLtr ? "Normal" : <MultiLanTxt tid="NORMAL_SCREEN" />}
              </span>
              <FullscreenExitIcon
                className={classes.tableFeatureIcon}
                onClick={(e) => {
                  e.preventDefault();
                  setFullScreen(false);
                }}
              />
            </>
          ) : (
            <>
              <span className={classes.tooltip}>
                {forceLtr ? "Full width" : <MultiLanTxt tid="FULL_SCREEN" />}
              </span>
              <FullscreenIcon
                className={classes.tableFeatureIcon}
                onClick={(e) => {
                  e.preventDefault();
                  setFullScreen(true);
                }}
              />
            </>
          )}
        </span>
      </div>
    </div>
  );
};

export default TableHeader;
